<template>
	<el-dropdown v-bind="{...$attrs, type, splitButton}">
		<el-button v-bind="{size:'small', disabled}">
			{{ mainButtonName }}<i class="el-icon-arrow-down el-icon--right" />
		</el-button>
		<slot />
		<el-dropdown-menu slot="dropdown">
			<el-dropdown-item v-for="item in items" :key="item.labelKey" @click.native="item.click">
				{{ buttonName(item) }}
			</el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
</template>

<script>
import { DmsBaseComponent } from '#components/dms/common/base';
import { BUTTON_TYPES } from '#components/@types/button';


export default DmsBaseComponent.extend({
	name: 'DmsDropdownButton',
	props: {
		text: String,
		splitButton: true,
		type: {
			type: String,
			in: BUTTON_TYPES,
		},
		items: Array,
	},
	computed: {
		mainButtonName() {
			return this.text || this.LocalizePopisostatni(this.labelKey);
		},
		showLabel() {
			return !!(this.labelKey || this.text);
		},
	},
	methods: {
		buttonName(item) {
			return item.text || this.LocalizePopisostatni(item.labelKey);
		},
	},
});
</script>

<style lang="scss">
.el-dropdown {
	.el-button:not(.el-dropdown__caret-button) {
		padding-right: 3px;
		height: 30px;
   		margin-top: 1px;
	}
}
</style>
